var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraduation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5586 4.78752L8.58512 2.10939C8.20512 1.96345 7.79512 1.96345 7.41537 2.10939L0.441619 4.78752C-0.146881 5.01345 -0.146881 5.98627 0.441619 6.2122L1.65737 6.67908C1.39062 7.09127 1.22662 7.59408 1.21037 8.14471C0.969619 8.31721 0.800119 8.62846 0.800119 9.00002C0.800119 9.33689 0.942119 9.62033 1.14662 9.80158L0.508369 13.3916C0.452869 13.7038 0.642869 14 0.898619 14H2.30137C2.55737 14 2.74737 13.7038 2.69187 13.3916L2.05362 9.80158C2.25812 9.62033 2.40012 9.33689 2.40012 9.00002C2.40012 8.63846 2.23837 8.33596 2.00862 8.16033C2.02762 7.69096 2.21962 7.27596 2.52587 7.01283L7.41512 8.89064C7.64162 8.97752 8.07612 9.08596 8.58487 8.89064L15.5586 6.21252C16.1474 5.98627 16.1474 5.01377 15.5586 4.78752ZM8.81987 9.84658C8.10662 10.1203 7.49887 9.96908 7.18012 9.84658L3.55462 8.45439L3.20012 12C3.20012 13.1047 5.34912 14 8.00012 14C10.6511 14 12.8001 13.1047 12.8001 12L12.4456 8.45408L8.81987 9.84658Z",
    fill: "#BDBDBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduation);
export default __webpack_public_path__ + "static/media/graduation.4969a00bc05aba9719bf34ef79e48bb5.svg";
export { ForwardRef as ReactComponent };